import appConst from "./appConst.json";

const UI_ITEM_FILTER_PREFIX_ALIASES = {
  "803": appConst.VERSION_TREE_V3_PREFIX,
};

export const getItemFilterPrefix = (itemFilter) => {
  if (!itemFilter || typeof itemFilter !== "string") {
    return null;
  }

  const parts = itemFilter.split(".");
  return parts.length > 0 ? parts[0] : null;
};

export const getUiItemFilterPrefix = (itemFilter) => {
  const prefix = getItemFilterPrefix(itemFilter);
  if (!prefix) {
    return null;
  }

  return UI_ITEM_FILTER_PREFIX_ALIASES[prefix] || prefix;
};
